import React from "react";

function CallIcon(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      fill="none"
      viewBox="0 0 26 25"
    >
      <circle
        cx="13"
        cy="12.5"
        r="12.202"
        stroke="#FF752C"
        strokeWidth="0.595"
      ></circle>
      <path
        fill="#FF752C"
        d="M14.016 7.952a.333.333 0 01.41-.237 4.701 4.701 0 013.362 3.362.334.334 0 01-.527.352.335.335 0 01-.12-.179 4.037 4.037 0 00-2.888-2.888.335.335 0 01-.237-.41zm-.21 2.196c.813.216 1.333.737 1.55 1.549a.335.335 0 00.647-.173c-.28-1.044-.979-1.744-2.023-2.023a.335.335 0 00-.173.647zm4.434 5.413a3.027 3.027 0 01-3.007 2.634c-4.37 0-7.924-3.555-7.924-7.924A3.027 3.027 0 019.94 7.264a.781.781 0 01.812.468l1.178 2.628a.78.78 0 01-.086.773l-1.176 1.398a.106.106 0 000 .094c.428.875 1.345 1.785 2.232 2.212a.107.107 0 00.094-.003l1.378-1.172a.781.781 0 01.772-.092l2.636 1.182a.781.781 0 01.459.81v-.001zm-.663-.083a.112.112 0 00-.068-.111l-2.637-1.182a.107.107 0 00-.09.006l-1.376 1.172a.781.781 0 01-.8.08c-1.024-.496-2.046-1.508-2.54-2.523a.781.781 0 01.074-.798l1.175-1.4a.11.11 0 000-.093L10.14 8a.112.112 0 00-.103-.073h-.012a2.357 2.357 0 00-2.047 2.344c0 4 3.255 7.254 7.255 7.254a2.357 2.357 0 002.343-2.047z"
      ></path>
    </svg>
  );
}

export default CallIcon;
